import { AsurionLogoDark } from "@expert/common-ui/assets/AsurionLogoDark";
import { Center, Flex, Space, Stack, Text } from "@mantine/core";
import { useAgentStore } from "@/sdk";
import { userCache } from "@/shared-utils";

const LOGO_SIZE = "var(--mantine-spacing-4xl)";
function useExpertName(): string {
    const agentName = useAgentStore((state) => state.agentName);

    if (userCache.givenName) {
        return userCache.givenName;
    }

    const splitName = agentName?.split(".");
    return splitName.length > 0 ? splitName[0] : agentName;
}

export function NoActiveChatView() {
    const expertName = useExpertName();

    return (
        <Stack id="no-active-chat-view" align="center" justify="center" flex={1} gap={0}>
            <Center h={LOGO_SIZE} w={LOGO_SIZE}>
                <AsurionLogoDark />
            </Center>
            <Space h="lg" />
            <Flex>
                <Text fw="bold" tt="capitalize">
                    Hello {expertName}
                </Text>
                <Text>&mdash;let’s provide great service today!</Text>
            </Flex>
        </Stack>
    );
}
